<div>
  <a href="javascript:void" (click)="openDetail()">{{ tariffId }}</a>
</div>
